import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { getAuthToken } from '../../../../../auth/tokenvalidation';
import ModeDeliveryTableFragment from '../../ModelDeliveryFragment';
import ParcelField from '../shared/ParcelField';

const HpsParcelNonLpg = ({ parcels = [], procurementId }) => {
  const token = getAuthToken();

  return parcels.map((parcel, index) => (
    <Card key={parcel.id || index} className='border shadow-sm mb-3'>
      <CardBody>
        <ParcelField parcel={parcel} />
        {procurementId && parcel?.id && token ? (
          <ModeDeliveryTableFragment
            procurementId={procurementId}
            quantityDeliveryTermId={parcel.id}
            token={token}
            infoPrompt={parcel.infoPrompt ?? parcel.infoPromptLabel}
          />
        ) : (
          <p className='text-muted small mb-0 mt-3'>
            No incoterm data available.
          </p>
        )}
      </CardBody>
    </Card>
  ));
};

export default HpsParcelNonLpg;
